import portfolio_create from "$root/assets/images/create-dialog[preload]/portfolio-create.svg";
import portfolio_upload_quantities from "$root/assets/images/create-dialog[preload]/portfolio-upload-quantities.svg";
import portfolio_upload_weights from "$root/assets/images/create-dialog[preload]/portfolio-upload-weights.svg";
import { typedUrlForRoute } from "$root/components/PlatformRouter/RoutesDef";
import { canCreateInQuantities } from "$root/functional-areas/instruments-editor/quantity/gate";
import type { IUser } from "$root/functional-areas/user";
import type { SpawnResult } from "@mdotm/shadcn/legacy/react-extensions";
import { spawnMultipleChoiceCreationDialog } from "./MultipleChoiceCreationDialog";

export function spawnPortfolioCreationDialog({
	intentId,
	user,
}: {
	intentId?: string;
	/** Decides whether the "Upload and/or Set Quantities" option is offered (`canCreateInQuantities`). */
	user: Pick<IUser, "availableServices">;
}): SpawnResult<void> {
	return spawnMultipleChoiceCreationDialog({
		options: [
			{
				href: typedUrlForRoute("Portfolios/CreatePortfolio", { intentId }),
				"data-qualifier": "PortfolioStudio/PortfolioList/NewPortfolio/Create",
				icon: portfolio_create,
				title: "Create",
				description: "Set constraints and targets and let Sphere create a portfolio for you.",
			},
			{
				href: typedUrlForRoute("Portfolios/ManualPortfolioCreation", { intentId }),
				"data-qualifier": "PortfolioStudio/PortfolioList/NewPortfolio/UploadEditor",
				icon: portfolio_upload_weights,
				title: "Upload and/or Set Weights",
				description: "Import existing portfolios and set weights.",
			},
			...(canCreateInQuantities(user)
				? [
						{
							href: typedUrlForRoute("Portfolios/ManualPortfolioCreation", { intentId, quantityMode: "true" }),
							"data-qualifier": "PortfolioStudio/PortfolioList/NewPortfolio/UploadQuantitiesEditor",
							icon: portfolio_upload_quantities,
							title: "Upload and/or Set Quantities",
							description: "Import existing portfolios and set quantities against a fixed AUM.",
						},
					]
				: []),
		],
	});
}
